module.exports = __webpack_public_path__ + "static/media/illustration_upgrade.44cb2fb6.svg";